<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-container">
				<div class="flex flex-row items-center border-b-default border-border-color">
					<div class="flex flex-1 items-center p-4" :class="$attrs.headerClass">
						<slot name="header">
							<h2>{{ title }}</h2>
						</slot>
					</div>
					<app-icon
						v-if="!persistent"
						class="text-2xl text-secondary mr-4 cursor-pointer"
						:icon="closeIcon ? closeIcon : 'cancel'"
						@click="$emit('close')"
					/>
				</div>

				<div class="modal-body">
					<slot />
				</div>

				<div class="modal-footer">
					<slot name="footer" />
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import AppIcon from '@/components/app/AppIcon';
	export default {
		name: 'AppModal',
		components: { AppIcon },
		props: ['title', 'persistent', 'closeIcon'],
		data() {
			return {
				modalOpen: false,
				delayedModalOpen: false,
			};
		},
		methods: {
			open() {
				if (!this.modalOpen) {
					this.modalOpen = true;
				}
			},
			close() {
				this.modalOpen = false;
				this.delayedModalOpen = false;
			},
		},
	};
</script>
